import { FC } from "react";
import * as _ from "lodash";

import { useTranslation, Enterprise as Content } from "@ctra/i18n";
import { Switch, Typography, Table, Divider, Space } from "@ctra/components";
import { useFarmList } from "@farms";

const { Text } = Typography;

const {
  settings: {
    farmPreferences: { switchLabels, tableHeaders, description }
  }
} = Content;

interface FarmNamePreferenceProps {
  useObfuscatedNames: boolean;
  onChange: (useObfuscated: boolean) => void;
}

/**
 * Component to toggle between displaying farm names as obfuscated or real names.
 * @param {boolean} useObfuscatedNames
 * @param {(useObfuscated: boolean) => void} onChange
 * @returns {JSX.Element}
 * @constructor
 */
const FarmNamePreference: FC<FarmNamePreferenceProps> = ({ useObfuscatedNames, onChange }) => {
  const { t } = useTranslation();
  const { farmList } = useFarmList();

  return (
    <>
      <Space>
        <Switch
          checked={useObfuscatedNames}
          onChange={onChange}
          checkedChildren={t<string>(switchLabels.obfuscated)}
          unCheckedChildren={t<string>(switchLabels.real)}
        />

        <Text size="sm" type="secondary">
          {useObfuscatedNames ? t<string>(description.obfuscated) : t<string>(description.real)}
        </Text>
      </Space>
      {useObfuscatedNames ? (
        <>
          <Divider></Divider>
          <Table
            dataSource={_.sortBy(farmList, "name")}
            columns={[
              {
                title: t<string>(tableHeaders.farmName),
                dataIndex: "name",
                key: "name"
              },
              {
                title: t<string>(tableHeaders.obfuscatedName),
                dataIndex: "obfuscatedName",
                key: "obfuscatedName"
              }
            ]}
          ></Table>
        </>
      ) : null}
    </>
  );
};

export default FarmNamePreference;
